export default {
  en: 'English',
  es: 'Spanish',
};
